import React, { useState } from "react";
import { Card } from "../components/Card";
import { Container } from "../styles/styles";
import styled from "styled-components";
import { motion } from "framer-motion";
import Confetti from "react-dom-confetti";

const confettiConfig = {
  angle: 90,
  spread: 360,
  startVelocity: 40,
  elementCount: 100,
  dragFriction: 0.12,
  duration: 3000,
  stagger: 3,
  width: "5px",
  height: "10px",
  perspective: "500px",
  colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
};

const HomeScreen = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  return (
    <Container>
      {/* <H1>Personal Manifesto</H1>
      <H2>Mike Hendriks</H2>
      <ScrollIndicator /> */}
      {/* <CardContainer variants={container} animate="show" initial="hidden"> */}
      <CardContainer>
        {data.map((item, i) => (
          <Card
            title={item.title}
            subtitle={item.subtitle}
            number={i + 1}
            key={i}
            backgroundColor={item.backgroundColor}
            textColor={item.textColor}
            setShowConfetti={setShowConfetti}
            rotate={item.rotate}
          />
        ))}
      </CardContainer>
      <StyledSignagute>
        Download the <br /> app for more 😉
      </StyledSignagute>
      <StyledConfetti active={showConfetti} config={confettiConfig} />
    </Container>
  );
};

export default HomeScreen;

const CardContainer = styled(motion.div)`
  z-index: 1;
  position: relative;
  width: auto;
  height: 420px;
  display: flex;
  justify-content: center;
`;

const StyledConfetti = styled(Confetti)`
  position: fixed !important;
  right: 0;
  top: 50%;
`;

const StyledSignagute = styled.div`
  position: absolute !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  font-size: 26px;

  span {
    font-size: 12px;
  }
`;

const data = [
  {
    title: "Reconnect with an old friend",
    backgroundColor: "#F9F7E6",
    textColor: "#35C1AC",
    rotate: 5,
  },
  {
    title: "Leave your smartphone at home",
    backgroundColor: "#038F97",
    textColor: "#FFF8D6",
    rotate: 1,
  },
  {
    title: "Lie down on the ground in public for about 30 seconds",
    backgroundColor: "#FA8184",
    textColor: "#FFF8D6",
    rotate: -5,
  },
  // {
  //   title: "Try something new",
  // (backgroundColor: "#C9E4DC"),
  // (textColor: "#F53763"),
  //   rotate: 2,
  // },
  // {
  //   title: "Fuck other’s opinions",
  //   backgroundColor: "#D8667F",
  //   textColor: "#F9DF8A",
  //   rotate: 9,
  // },
  // {
  //   title: "If you do something, do it right",
  //   backgroundColor: "#FFB694",
  //   textColor: "#FFF8D6",
  //   rotate: -1,
  // },
  // {
  //   title: "Balance your work and personal life",
  //   backgroundColor: "#FA8184",
  //   textColor: "#FFF8D6",
  //   rotate: 6,
  // },
  // {
  //   title: "Be kind",
  //   backgroundColor: "#038F97",
  //   textColor: "#FFF8D6",
  //   rotate: 2,
  // },
  // {
  //   title: "Worry less",
  //   backgroundColor: "#C9E4DC",
  //   textColor: "#F53763",
  //   rotate: -3,
  // },
  // {
  //   title: "You never know until you ask",
  //   backgroundColor: "#F9F7E6",
  //   textColor: "#35C1AC",
  //   rotate: 0,
  // },
  // {
  //   title: "Less is more",
  //   backgroundColor: "#FFB694",
  //   textColor: "#FFF8D6",
  //   rotate: 1,
  // },
  // {
  //   title: "Fuck yesterday",
  //   backgroundColor: "#D8667F",
  //   textColor: "#F9DF8A",
  //   rotate: -1,
  // },
];
